import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useAuthUser } from '~/shared/hooks/auth-hooks';
import { getGaUserGroup } from '~/shared/utils/is-wavin-email';

export function useGoogleAnalyticsUserProperties({
  enabled,
}: {
  enabled?: boolean;
}) {
  const authUser = useAuthUser();

  useEffect(() => {
    if (!enabled || !authUser?.email) {
      return;
    }

    ReactGA.gtag('set', 'user_properties', {
      user_group: getGaUserGroup(authUser.email),
      is_installer: String(authUser.isInstaller),
    });
  }, [enabled, authUser?.email, authUser?.isInstaller]);
}
